import { useNavigate } from "react-router-dom";
import logo from "../assets/images/logo/Logo-Schofin-12.png";

const Unauthorized = () => {
  const navigate = useNavigate();

  const goBack = () => navigate("/");

  return (
    <div className="flex relative w-full h-full min-h-screen bg-teal-500 dark:bg-gray-800 px-2 xl:pr-[20px]">
      <div className="xl:my-[200px] xl:mx-[800px] mb-10 xl:w-1/4 w-full pt-40 lg:pt-0">
        <div className="flex mx-auto my-auto">
          <div className="mt-5 w-full md:w-1/2 lg:w-1/2 xl:w-full px-5 mx-auto rounded bg-slate-100 shadow-xl">
            <div>
              <div className="text-base w-full font-bold text-center pt-5 block whitespace-nowrap dark:text-white">
                <img
                  src={logo}
                  alt=""
                  className="pl-2 w-24 sm:w-28 md:w-36 mx-auto"
                />
              </div>
              <h1 className="font-semibold text-white bg-red-500 text-2xl text-center mb-1 lg:text-xl w-full py-1 shadow-xl rounded mt-3">
                401 Unauthorized
              </h1>
              {/* Content */}
              <div className="lg:py-1 lg:px-6 text-sm text-teal-600 font-semibold text-center">
                <p>Akses untuk mengakses halaman di batasi.</p>
              </div>
              <div className="mt-4 flex w-full">
                <div className="justify-end mx-auto">
                  <button
                    type="button"
                    className="py-1.5 px-5 bg-teal-500 hover:bg-teal-600 active:bg-teal-900 shadow-xl rounded text-white"
                    onClick={goBack}
                  >
                    Go Back
                  </button>
                </div>
              </div>
            </div>
            <div className="overflow-auto m-5 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
